import { memo } from 'react';

interface SectionTitleProps {
  children: React.ReactNode;
}

const SectionTitle = memo(({ children }: SectionTitleProps) => (
  <h4
    className="text-sm font-bold text-blue-950 mb-4 pl-2 relative
               before:content-[''] before:absolute before:left-0 before:top-1/2
               before:-translate-y-1/2 before:w-[3px] before:h-3
               before:bg-gradient-to-b before:from-[#ff5900] before:to-[#0f53ba]
               before:rounded-sm"
  >
    {children}
  </h4>
));

SectionTitle.displayName = 'SectionTitle';

export default SectionTitle;